import classes from "../../Styles/Styles.module.css";

export const RestartPage = () => {
    return (
        <div className={classes.noPage}></div>
    )
}